import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Noticia } from 'src/app/models/noticia.model';
import { daApi, listaDaApi, MAP_NOTICIA, ORDEM_NOTICIA, paraApi, parametrosLista } from '../api-map';

@Injectable({
  providedIn: 'root'
})
export class NoticiaService {

  constructor(
    public api: ApiService
  ) { }

  get(numeroPagina: number, registroPorPagina: number, ordenacao: string, sentidoOrdenacao: string, filtro?: string): Observable<NoticiasApi> {
    const query = parametrosLista(numeroPagina, registroPorPagina, ordenacao, sentidoOrdenacao, filtro, ORDEM_NOTICIA, 'date');

    return this.api.get('/news' + query).pipe(
      map((res: any) => {
        const lista = listaDaApi(res, MAP_NOTICIA);
        return { noticias: lista.itens, numeroPaginas: lista.numeroPaginas } as NoticiasApi;
      })
    );
  }

  getById(id): Observable<any> {
    return this.api.get(`/news/${id}`).pipe(map((res: any) => daApi(res, MAP_NOTICIA)));
  }

  getBySlug(slug: string): Observable<any> {
    return this.api.get(`/news/slug/${slug}`).pipe(map((res: any) => daApi(res, MAP_NOTICIA)));
  }

  post(noticia: Noticia): Observable<any> {
    return this.api.post('/news', paraApi(noticia, MAP_NOTICIA)).pipe(map((res: any) => daApi(res, MAP_NOTICIA)));
  }

  patch(noticia: Noticia): Observable<any> {
    return this.api.patch('/news', paraApi(noticia, MAP_NOTICIA)).pipe(map((res: any) => daApi(res, MAP_NOTICIA)));
  }

  delete(noticia: Noticia): Observable<any> {
    return this.api.delete(`/news/${noticia.id}`);
  }

  deleteSelected(noticias: Noticia[]): Observable<any> {
    return this.api.deleteComCorpo('/news', noticias.map(n => ({ id: n.id })));
  }

  postFile(file: File, url: string, fileName: string) {
    return this.api.postFile(file, url, fileName);
  }
}

export interface NoticiasApi {
  noticias: Noticia[];
  numeroPaginas: number;
}
